module.exports = __webpack_public_path__ + "img/lusterka-miniatura.ed206002.jpg";